export function getIFrameLocation(iframeId) {
    const iframe = document.getElementById(iframeId)
    const location = iframe.contentWindow.location
    return location
}
